import { en, type MessageKey } from './en';

export type { MessageKey };
export type Params = Readonly<Record<string, string | number>>;

const catalogs: Readonly<Record<string, Partial<Record<MessageKey, string>>>> = { en };
let locale = 'en';

export const availableLocales = (): string[] => Object.keys(catalogs);

export function setLocale(next: string): void {
  if (catalogs[next]) locale = next;
}

export const currentLocale = (): string => locale;

/**
 * Looks up a string and fills its {parameters}; falls back to English, then to the key. A
 * sentence that starts with a parameter starts with a capital ("the pawn on D5 is captured…" is
 * "The pawn on D5 is captured…").
 */
export function t(key: MessageKey, params?: Params): string {
  const template = catalogs[locale]?.[key] ?? en[key] ?? key;
  if (!params) return template;
  const text = template.replace(/\{(\w+)\}/g, (m, name: string) =>
    name in params ? String(params[name]) : m,
  );
  return template.startsWith('{') && /[.?!]$/.test(text)
    ? text.charAt(0).toLocaleUpperCase() + text.slice(1)
    : text;
}
